if (!customElements.get('product-lightbox')) {
  class ProductLightbox extends HTMLElement {
    connectedCallback() {
      this.gallery = this.closest('media-gallery');
      this.slides = Array.from(this.querySelectorAll('.product-lightbox__slide'));
      this.counter = this.querySelector('.product-lightbox__counter');
      this.currentIndex = 0;
      this.pointerStartX = null;

      this.gallery.querySelectorAll('.js-zoom-link').forEach((link) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          this.open(link.dataset.mediaId);
        });
      });

      this.querySelectorAll('[data-lightbox-close]').forEach((button) => {
        button.addEventListener('click', () => this.close());
      });

      this.querySelector('[data-lightbox-prev]')?.addEventListener('click', () => this.showPrevious());
      this.querySelector('[data-lightbox-next]')?.addEventListener('click', () => this.showNext());
      this.addEventListener('keydown', (event) => this.handleKeydown(event));
      this.addEventListener('pointerdown', (event) => {
        this.pointerStartX = event.clientX;
      });
      this.addEventListener('pointerup', (event) => this.handleSwipe(event));
    }

    open(mediaId) {
      const matchedIndex = this.slides.findIndex((slide) => slide.dataset.mediaId === mediaId);
      this.currentIndex = matchedIndex >= 0 ? matchedIndex : 0;
      this.hidden = false;
      document.body.classList.add('product-lightbox-open');
      this.showCurrent();
      this.querySelector('.product-lightbox__close').focus();
    }

    close() {
      this.hidden = true;
      document.body.classList.remove('product-lightbox-open');
    }

    showCurrent() {
      this.slides.forEach((slide, index) => {
        slide.hidden = index !== this.currentIndex;
      });
      if (this.counter) this.counter.textContent = `${this.currentIndex + 1} / ${this.slides.length}`;
    }

    showPrevious() {
      this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
      this.showCurrent();
    }

    showNext() {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
      this.showCurrent();
    }

    handleKeydown(event) {
      if (event.key === 'Escape') this.close();
      if (event.key === 'ArrowLeft') this.showPrevious();
      if (event.key === 'ArrowRight') this.showNext();
    }

    handleSwipe(event) {
      if (this.pointerStartX === null) return;
      const distance = event.clientX - this.pointerStartX;
      this.pointerStartX = null;
      if (Math.abs(distance) < 50) return;
      if (distance > 0) this.showPrevious();
      if (distance < 0) this.showNext();
    }
  }

  customElements.define('product-lightbox', ProductLightbox);
}
